import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import ProductCard from "../ProductCard/ProductCard";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import { mapProduct } from "../../models/Product/ProductResponseModel";
import emptyImg from "../../assets/empty-cart.png";
import "./CategoryProducts.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function CategoryProducts() {

  const navigate = useNavigate();
  const { search } = useLocation();

  const params = new URLSearchParams(search);
  const categoryName = params.get("category") || "";

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {

    if (!categoryName) {
      setLoading(false);
      return;
    }

    const fetchProducts = async () => {

      setLoading(true);
      setError("");

      try {

        const token = localStorage.getItem("token");
const headers = token
  ? { Authorization: `Bearer ${token}` }
  : {};
        /* ================================
           NORMALIZE CATEGORY
        ================================= */

        // const normalizedCategory =
        //   categoryName === "السوق"
        //     ? ""
        //     : categoryName;

        // /* ================================
        //       FETCH PRODUCTS
        // ================================= */

        // const normalRes = await axios.get(
        //   BaseUrl + BuyerServicesUrl.GetProductList,
        //   {
        //     headers: { Authorization: `Bearer ${token}` },
        
        //     params: {
        //       type: "normal",
        //       ...(normalizedCategory && {
        //         category_name: normalizedCategory
        //       })
        //     }
        //   }
        // );
const categoryMap = {
  "الكتروني": "الكترونيات",
  "الكترونيات": "الكترونيات",
  "ازياء": "ازياء",
  "صحه": "صحه",
  "مطبخ": "مطبخ",
  "ألعاب": "العاب",
  "اثاث": "اثاث",
};

const normalizedCategory =
  categoryName === "السوق"
    ? ""
    : categoryMap[categoryName] || categoryName;
    console.log("CATEGORY SENT TO API:", normalizedCategory);
//  const normalRes = await axios.get(
//   BaseUrl + BuyerServicesUrl.GetProductList,
//   {
//     headers: { Authorization: `Bearer ${token}` },
//     params: {
//       type: "normal",
//       ...(normalizedCategory && {
//         category_name: normalizedCategory
//       })
//     }
//   }
// );

// const adsRes = await axios.get(
//   BaseUrl + BuyerServicesUrl.GetProductList,
//   {
//     headers: { Authorization: `Bearer ${token}` },
//     params: {
//       type: "ads",
//       ...(normalizedCategory && {
//         category_name: normalizedCategory
//       })
//     }
//   }
// );
const [normalRes, adsRes] = await Promise.all([
  axios.get(BaseUrl + BuyerServicesUrl.GetProductList, {
    headers,
    params: {
      type: "normal",
      ...(normalizedCategory && {
        category_name: normalizedCategory
      })
    }
  }),

  axios.get(BaseUrl + BuyerServicesUrl.GetProductList, {
    headers,
    params: {
      type: "ads",
      ...(normalizedCategory && {
        category_name: normalizedCategory
      })
    }
  })
]);
        /* ================================
             MAP PRODUCTS
        ================================= */

        const normalProducts =
          normalRes.data?.data?.map(mapProduct) || [];

        const adsProducts =
          adsRes.data?.data?.map(mapProduct) || [];

        setProducts([
          ...adsProducts,
          ...normalProducts
        ]);

      } catch (err) {

        // if (err.response?.status === 401) {
        //   navigate("/login");
        // } else {
          setError("حدث خطأ أثناء تحميل المنتجات");
        // }

      } finally {
        setLoading(false);
      }

    };

    fetchProducts();

  }, [categoryName, navigate]);


  /* ================================
            LOADING
  ================================= */

  if (loading) {
    return (
      <div className="productList mt-5 pt-5">
        
        <div className="container mt-5">
          <div className="orders-loader text-center py-5">
            <div className="loader-circle mb-3"></div>
            <p className="fw-bold">
              جاري تحميل المنتجات...
            </p>
          </div>
        </div>
      </div>
    );
  }

  /* ================================
         NO CATEGORY
  ================================= */

  if (!categoryName)
    return (
      <div className="empty-center mt-5">
        <h4>لم يتم اختيار فئة</h4>
      </div>
    );

  /* ================================
              ERROR
  ================================= */

  if (error)
    return (
      <div className="empty-center mt-5">
        <h4 className="text-danger">{error}</h4>
      </div>
    );

  /* ================================
          EMPTY PRODUCTS
  ================================= */

  if (products.length === 0)
    return (
      <div className="empty-center mt-5 pt-5 d-flex flex-column align-items-center justify-content-center">
        <img
          src={emptyImg}
          alt="No Products"
          className="mt-5 mb-5 pt-5"
          style={{ width: "260px", opacity: 0.7 }}
        />
        <h4 className="mb-5 pb-5 text-muted">
          لا توجد منتجات في هذه الفئة
        </h4>
      </div>
    );


  /* ================================
            PRODUCTS GRID
  ================================= */
 

  return (
    <div className="productList mt-5 pt-5">
        <ToastContainer
      position="bottom-right"
      autoClose={2000}
      rtl
      theme="colored"
    />

      {/*<h2 className="mb-4 fw-bold">
        {categoryName}
      </h2>*/}

      <div className="row mt-5 pt-5 mb-5 pb-5 d-flex justify-content-end">

        {products.map((item) => (

          <div
            key={item.id}
            className="col-xl-3 col-lg-3 col-md-4 col-sm-6 mb-4"
          >
            <ProductCard product={item} />
          </div>

        ))}

      </div>

    </div>
  );

}